import gql from 'graphql-tag';

import { FRAGMENT_BLOG_POST_BUILDER_DRAFT } from 'src/graphql/blog/schema';
import { BRIEF_FRAGMENT } from 'src/graphql/brief';
import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { CUSTOMER_FRAGMENT } from 'src/graphql/customer';
import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from 'src/graphql/longFormBuilder/schema';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProject, BackendQueryProjectArgs } from 'src/types/backend';

import { PROJECT_FRAGMENT } from './schema';

const QUERY = gql`
  query Project($id: Int!) {
    project(id: $id) {
      ...Project

      customer {
        ...Customer
      }

      brief {
        ...Brief
      }

      longFormBuilderDrafts {
        ...LongFormBuilderDraft
      }

      blogPostBuilderDrafts {
        ...BlogPostBuilderDraft
      }
    }
  }
  ${PROJECT_FRAGMENT}
  ${BRIEF_FRAGMENT}
  ${CUSTOMER_FRAGMENT}
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
  ${FRAGMENT_BLOG_POST_BUILDER_DRAFT}
`;

type Variables = BackendQueryProjectArgs;
type Result = BackendProject;

export const queryProject = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(result.data);
};
